import React from 'react';

import type { SelectProps } from 'antd';
import styled from 'styled-components';

import DownCaretIcon from 'common/Icons/DownCaretIcon';
import Select from 'components/lib/Select';

const StyledMenu = styled.div`
  .ant-select-item {
    font-size: 14px;
    padding: 6px 10px;
    border-bottom: 1px solid var(--line-gray);
  }
`;

type RectangularSelectProps = SelectProps<any>;

const RectangularSelect = ({ style, dropdownStyle, onMouseDown, onClick, ...props }: RectangularSelectProps) => {
  const handleMouseDown = (event: React.MouseEvent<HTMLDivElement>) => {
    event.stopPropagation();
    if (typeof onMouseDown === 'function') {
      onMouseDown(event);
    }
  };

  const handleClick = (event: React.MouseEvent<HTMLDivElement>) => {
    event.stopPropagation();
    if (typeof onClick === 'function') {
      onClick(event);
    }
  };

  return (
    <Select
      className="rectangular"
      suffixIcon={<DownCaretIcon />}
      style={{
        width: 200,
        height: 36,
        borderRadius: 0,
        ...(style || {}),
      }}
      dropdownRender={(menu) => <StyledMenu>{menu}</StyledMenu>}
      dropdownStyle={{
        padding: 0,
        borderRadius: 0,
        border: '1px solid var(--line-gray)',
        boxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.1)',
        ...(dropdownStyle || {}),
      }}
      onMouseDown={handleMouseDown}
      onClick={handleClick}
      {...props}
    />
  );
};

export default RectangularSelect;
